export const enAuth = {
  pageTitle: "Log in",
  submit: "Log in",
} as const;
